const MONTHS_SHORT = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
const nth = (d) => {
  if (d > 3 && d < 21) return 'th'
  switch (d % 10) {
    case 1:
      return "st"
    case 2:
      return "nd"
    case 3:
      return "rd"
    default:
      return "th"
  }
}
const zeroPad = d => {
  return d < 10 ? `0${d}` : d
}
export default {
  methods: {
    renderDate(dateString) {
      let d = new Date(dateString)
      return `${d.getDate()}${nth(d.getDate())} ${MONTHS_SHORT[d.getMonth()]} ${d.getFullYear()}`
    },
    renderDateAndTime(dateString) {
      let d = new Date(dateString)
      return `${d.getDate()}${nth(d.getDate())} ${MONTHS_SHORT[d.getMonth()]} ${d.getFullYear()}
       ${zeroPad(d.getHours())}:${zeroPad(d.getMinutes())}`
    }
  }
}
